// extracted by mini-css-extract-plugin
export default {"container":"ModalHeader_container__HSutU","header":"ModalHeader_header__neEwK","content":"ModalHeader_content__ZrCIf","button":"ModalHeader_button__gUn9m"};